import { featuredPicks } from '@/mocks/nav';

interface FeaturedSectionProps {
  onJump: (keyword: string) => void;
}

export default function FeaturedSection({ onJump }: FeaturedSectionProps) {
  const [lead, ...rest] = featuredPicks;

  return (
    <section
      id="featured"
      className="scroll-mt-20 border-b border-background-200 bg-background-50 py-14 md:scroll-mt-24 md:py-20"
    >
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-widest text-accent-700 md:text-sm">
              <i className="ri-medal-line text-base" aria-hidden="true"></i>
              Editor&apos;s Picks
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">精选推荐</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              编辑从稳定度、更新频率与内容质量三个维度，挑出近期值得长期收藏的入口，帮你少走弯路。
            </p>
          </div>
          <button
            type="button"
            onClick={() => onJump('')}
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            浏览全部入口
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </button>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-5 md:mt-10 md:gap-5">
          <article className="lg:col-span-3">
            <div className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative h-52 w-full md:h-72">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20flat%20illustration%20of%20glowing%20orange%20hot%20topic%20cards%20floating%20on%20a%20warm%20cream%20background%2C%20abstract%20geometric%20shapes%2C%20minimal%20modern%20poster%20art%2C%20no%20text&width=1200&height=720&seq=featured-lead-01&orientation=landscape"
                  alt="本期编辑精选热门入口主题插画"
                  title="黑料导航 精选推荐"
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                  {lead.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-7">
                <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{lead.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700 md:text-base">{lead.summary}</p>
                <button
                  type="button"
                  onClick={() => onJump('热搜')}
                  className="mt-5 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  查看相关入口
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-2 md:gap-5">
            {rest.map((pick, index) => (
              <article
                key={pick.id}
                className="flex flex-1 flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">{pick.tag}</span>
                  <span className="font-heading text-2xl font-bold text-background-300">0{index + 2}</span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{pick.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{pick.summary}</p>
                <button
                  type="button"
                  onClick={() => onJump(index === 0 ? '剧集' : '赛事')}
                  className="mt-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
                >
                  查看相关入口
                  <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                </button>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}